'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileExtensionIcon = exports.timeFormatter = exports.fileSizeFormatter = exports.Uploader = undefined;

var _src = require('./src');

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Uploader = _src2.default;
exports.fileSizeFormatter = _src.fileSizeFormatter;
exports.timeFormatter = _src.timeFormatter;
exports.FileExtensionIcon = _src.FileExtensionIcon; /**
                                                     * Copyright (c) 2015-present, Zippy Technologies
                                                     *
                                                     * This source code is licensed under the MIT license found in the
                                                     * LICENSE file in the root directory of this source tree.
                                                     */

exports.default = _src2.default;
